const {KitModule, registerModule} = window;

/**
 * Escape text for safe use inside HTML.
 * @param {string} value
 * @returns {string}
 */
function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

/**
 * Wrap case-insensitive query matches in <mark>.
 * @param {string} title
 * @param {string} query
 * @returns {string}
 */
function highlightTitle(title, query) {
    if (!query) return escapeHtml(title);

    const lowerTitle = title.toLowerCase();
    const lowerQuery = query.toLowerCase();
    let html = '';
    let cursor = 0;
    let index = lowerTitle.indexOf(lowerQuery);

    while (index !== -1) {
        html += escapeHtml(title.slice(cursor, index));
        html += `<mark class="integrationsDirectory__mark">${escapeHtml(
            title.slice(index, index + query.length),
        )}</mark>`;
        cursor = index + query.length;
        index = lowerTitle.indexOf(lowerQuery, cursor);
    }

    html += escapeHtml(title.slice(cursor));
    return html;
}

/**
 * Client-side title filter + highlight for Integrations Directory.
 */
class IntegrationsDirectory extends KitModule {
    constructor($element) {
        super($element);

        if (this.$searchInput) {
            this.$searchInput.addEventListener('input', this);
        }
    }

    oninput() {
        this.filterCards();
    }

    filterCards() {
        const query = (this.$searchInput?.value || '').trim();
        const normalizedQuery = query.toLowerCase();
        let visible = 0;

        (this.$cards || []).forEach(($card) => {
            const title =
                $card.getAttribute('data-title') ||
                $card.getAttribute('data-search') ||
                '';
            const $title = $card.querySelector('.integrationsDirectory__card-title');
            const match =
                !normalizedQuery || title.toLowerCase().includes(normalizedQuery);

            $card.hidden = !match;

            if ($title) {
                $title.innerHTML = match ?
                    highlightTitle(title, normalizedQuery ? query : '') :
                    escapeHtml(title);
            }

            if (match) visible += 1;
        });

        if (this.$empty) {
            this.$empty.hidden = visible > 0;
        }
    }
}

registerModule('integrationsDirectory', IntegrationsDirectory);
